import firebase from "firebase/app";
import "firebase/auth"
import "firebase/firestore"
import "firebase/database"
import "firebase/functions"

const firebaseConfig = {
    apiKey: "AIzaSyAHxzZ9pb879QTXHeWqAln3uYLrAd0bX6A",
    authDomain: "pyramid-ce957.firebaseapp.com",
    databaseURL: "https://pyramid-areax.europe-west1.firebasedatabase.app",
    projectId: "pyramid-ce957",
    storageBucket: "pyramid-ce957.appspot.com",
    messagingSenderId: "687065228096",
    appId: "1:687065228096:web:5750cc3870975ac1e990a5",
};


// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const fireAuth = firebase.auth();
const firestore = firebase.firestore();
const fireRDB = firebase.database();
const fn = firebase.functions()
const functions = firebase.app().functions('europe-west3')

if (window.location.hostname === "localhost") {
    //firestore.useEmulator(window.location.hostname, 8080);
    //fireRDB.useEmulator(window.location.hostname, 9000)
    //functions.useEmulator(window.location.hostname, 5001);
}

export { firebase, fireAuth, firestore, fireRDB, functions }